import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../api/authApi";
import { chatApi } from "../api/chatApi";
import { dataConfidenceApi } from "../api/dataConfidenceApi";
import { mediaTypeApi } from "../api/mediaTypeApi";
import { productApi } from "../api/productApi";
import { retailerApi } from "../api/retailerApi";
import { scenarioApi } from "../api/scenarioApi";
import { settingsApi } from "../api/settingsApi";
import { userApi } from "../api/userApi";
import notificationsReducer from "../components/notify/notificationSlice";
import { authListenerMiddleware } from "../middleware/authListenerMiddleware";
import chatReducer from "../slices/chatSlice";
import userReducer from "../slices/userSlice";
import workspaceReducer from "../slices/workspaceSlice";
import { adminAppLogApi } from "../api/admin/adminAppLogApi";
import { adminChatConversationApi } from "../api/admin/adminChatConversationApi";
import { adminCustomerApi } from "../api/admin/adminCustomerApi";
import { adminUserApi } from "../api/admin/adminUserApi";
import { adminProductApi } from "../api/admin/adminProductApi";
import { adminRawSaleRecordApi } from "../api/admin/adminRawSaleRecordApi";
import { adminRetailerApi } from "../api/admin/adminRetailerApi";

export const store = configureStore({
    reducer: {
        chat: chatReducer,
        notifications: notificationsReducer,
        user: userReducer,
        workspace: workspaceReducer,
        [adminAppLogApi.reducerPath]: adminAppLogApi.reducer,
        [adminChatConversationApi.reducerPath]: adminChatConversationApi.reducer,
        [adminCustomerApi.reducerPath]: adminCustomerApi.reducer,
        [adminUserApi.reducerPath]: adminUserApi.reducer,
        [adminProductApi.reducerPath]: adminProductApi.reducer,
        [adminRawSaleRecordApi.reducerPath]: adminRawSaleRecordApi.reducer,
        [adminRetailerApi.reducerPath]: adminRetailerApi.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [chatApi.reducerPath]: chatApi.reducer,
        [dataConfidenceApi.reducerPath]: dataConfidenceApi.reducer,
        [mediaTypeApi.reducerPath]: mediaTypeApi.reducer,
        [productApi.reducerPath]: productApi.reducer,
        [retailerApi.reducerPath]: retailerApi.reducer,
        [scenarioApi.reducerPath]: scenarioApi.reducer,
        [settingsApi.reducerPath]: settingsApi.reducer,
        [userApi.reducerPath]: userApi.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .prepend(authListenerMiddleware.middleware)
        .concat(adminAppLogApi.middleware,
            adminChatConversationApi.middleware,
            adminCustomerApi.middleware,
            adminUserApi.middleware,
            adminProductApi.middleware,
            adminRawSaleRecordApi.middleware,
            adminRetailerApi.middleware,
            authApi.middleware,
            chatApi.middleware,
            dataConfidenceApi.middleware,
            mediaTypeApi.middleware,
            productApi.middleware,
            retailerApi.middleware,
            scenarioApi.middleware,
            settingsApi.middleware,
            userApi.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
